import Joi from 'joi'

export const tagsSchema = Joi.object({
  label: Joi.string().trim().max(20).required().messages({
    'string.empty': `Label cannot be an empty field`,
    'any.required': `Label is a required field`,
    'string.max': `Label length must be less than or equal to 20 characters`,
  }),
  color: Joi.any().required(),
})
